import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ResumeAnalysis } from '../resume-scoring/resume-analysis/resume-analyse-types';
import type { RootState } from 'lib/redux/store';
import { ScoreAnalysis } from 'lib/resume-scoring/types';

// Define types for the state
export interface ScoreAnalysisState {
  analysis: ResumeAnalysis | null;
  scoreAnalysis: ScoreAnalysis | null;
  score: number | null;
  experienceLevel: "FRESHER" | "EXPERIENCED" | null;
  isAnalysisLoading: boolean;
}

// Define initial state
const initialState: ScoreAnalysisState = {
  analysis: null,
  scoreAnalysis: null,
  score: null,
  experienceLevel: null,
  isAnalysisLoading: false,
};

// Create slice
export const scoreAnalysisSlice = createSlice({
  name: 'scoreAnalysis',
  initialState,
  reducers: {
    setAnalysis: (state, action: PayloadAction<ResumeAnalysis>) => {
      state.analysis = action.payload;
    },
    setScoreAnalysis: (state, action: PayloadAction<any>) => {
      state.scoreAnalysis = action.payload;
    },
    setScore: (state, action: PayloadAction<number>) => {
      state.score = action.payload;
    },
    setExperienceLevel: (state, action: PayloadAction<"FRESHER" | "EXPERIENCED" | null>) => {
      state.experienceLevel = action.payload;
    },
    setIsAnalysisLoading: (state, action: PayloadAction<boolean>) => {
      state.isAnalysisLoading = action.payload;
    },
    resetScoreAnalysis: (state) => {
      state.analysis = null;
      state.scoreAnalysis = null;
      state.score = null;
      state.experienceLevel = null;
    }
  },
});

// Export actions
export const { 
  setAnalysis, 
  setScoreAnalysis, 
  setScore, 
  setExperienceLevel,
  setIsAnalysisLoading,
  resetScoreAnalysis 
} = scoreAnalysisSlice.actions;

// Export selectors
export const selectAnalysis = (state: RootState) => state.scoreAnalysis.analysis;
export const selectScoreAnalysis = (state: RootState) => state.scoreAnalysis.scoreAnalysis;
export const selectScore = (state: RootState) => state.scoreAnalysis.score;
export const selectExperienceLevel = (state: RootState) => state.scoreAnalysis.experienceLevel;
export const selectIsAnalysisLoading = (state: RootState) => state.scoreAnalysis.isAnalysisLoading;

// Export reducer
export default scoreAnalysisSlice.reducer;